import React, {useState, useEffect} from 'react';
import {connect} from 'react-redux';
import {enToFa} from '../utils/NumberUtility';
import Numeral from 'numeral';
import {
    startgetVehicleBrands,
    startgetValidVehicle
} from '../actions/configs';
import {startCreateAlarm} from '../actions/alarms'

const JobRegister = (props) => {

    const [isSending, setSending] = useState(false);

    const [targetUsage, setTargetUsage] = useState("-1");
    const [targetUsageError, setTargetUsageError] = useState(false);
    const [brandValue, set_brandValue] = useState("-1")
    const [brandValueError, set_brandValueError] = useState(false)
    const [vehicleValue, set_VehicleValue] = useState("-1")
    const [vehicleValueError, set_vehicleValueError] = useState(false)

    const [fromPrice, setFromPrice] = useState("")
    const [fromPriceError, setFromPriceError] = useState(false)
    const [toPrice, setToPrice] = useState("")
    const [toPriceError, setToPriceError] = useState(false)

    const [fromYear, setFromYear] = useState("")
    const [fromYearError, setFromYearError] = useState(false)
    const [toYear, setToYear] = useState("")
    const [toYearError, setToYearError] = useState(false)

    const onUsageChanged = (e) => {
        console.log(e.target.value);
        if (e.target.value !== "-1" && e.target.value !== targetUsage) {
            props.fetchBrands(e.target.value)
            setTargetUsage(e.target.value)
            setTargetUsageError(false)
            set_brandValue("-1")
            set_brandValueError(false)
            set_VehicleValue("-1")
            set_vehicleValueError(false)
        }
    }

    const onBrandValueChanged = (e) => {
        if (e.target.value !== "-1" && e.target.value !== brandValue) {
            set_brandValue(e.target.value)
            props.fetchVehicles(e.target.value, targetUsage)
            set_VehicleValue("-1")
            set_brandValueError(false)
        }
    }

    const onVehicleValueChanged = (e) => {
        if (e.target.value !== "-1") {
            set_VehicleValue(e.target.value)
            set_vehicleValueError(false)
        }
    }

    const onFromPriceValueChanged = (e) => {
        const pureValue = e.target.value.replace(/,/g, "")
        if (!!pureValue.match(/^[0-9]*$/)) {
            setFromPrice(pureValue)
            setFromPriceError(false)
        }
    }

    const onToPriceValueChanged = (e) => {
        const pureValue = e.target.value.replace(/,/g, "")
        if (!!pureValue.match(/^[0-9]*$/)) {
            setToPrice(pureValue)
            setToPriceError(false)
        }
    }

    const onFromYearChanged = (e) => {
        if (!!e.target.value.match(/^[0-9]*$/)) {
            setFromYear(e.target.value)
            setFromYearError(false)
        }
    }
    
    const onToYearChanged = (e) => {
        if (!!e.target.value.match(/^[0-9]*$/)) {
            setToYear(e.target.value)
            setToYearError(false)
        }
    }

    const onNextPressed = () => {
        
        if (validateStepThree()) {
            onFinalizeForSend()
        }
    }

    const onFinalizeForSend = () => {
        let adBody = new FormData()
        if (vehicleValue !== "-1") {
            adBody.append("targetVehicle", vehicleValue)
        }
        if (fromPrice !== "") {
            adBody.append("fromPrice", fromPrice)
        }
        if (toPrice !== "") {
            adBody.append("toPrice", toPrice)
        }
        if (fromYear !== "") {
            adBody.append("fromYear", fromYear)
        }
        if (toYear !== "") {
            adBody.append("toYear", toYear)
        }
        setSending(true)
        props.createAd(adBody)
        .then(({success, error}) => {
            if (success){
                props.history.push('/dashboard')
            } else {
                setSending(false)
            }
        })
    }

    const validateStepThree = () => {
        let hasError = false;
        if (targetUsage === "-1") {
            setTargetUsageError(true)
            hasError = true
        } else {
            setTargetUsageError(false)
        }
        if (brandValue === "-1") {
            set_brandValueError(true)
            hasError = true
        } else {
            set_brandValueError(false)
        }
        if (vehicleValue === "-1") {
            set_vehicleValueError(true)
            hasError = true 
        } else {
            set_vehicleValueError(false)
        }
        if (fromPrice === "") {
            setFromPriceError(true)
            hasError = true
        } else {
            setFromPriceError(false)
        }
        if (toPrice === "") {
            setToPriceError(true)
            hasError = true
        } else {
            setToPriceError(false)
        }
        if (fromYear === "") {
            setFromYearError(true)
            hasError = true
        } else {
            setFromYearError(false)
        }
        if (toYear === "") {
            setToYearError(true)
            hasError = true
        } else {
            setToYearError(false)
        }
        return !hasError
    }

    return (
        
        <div className="container-sm optimized__d-flex-class flex-column h-100 mt-0 px-0 pb-4 justify-content-start about overflow-patch">
            <h1 className="register__page-title mb-4">درج گوش به زنگ</h1>
            <div className="optimized__d-flex-class flex-column px-4 mx-4 pb-4 about__description overflow-reset">
                <div className="optimized__d-flex-class flex-column py-3">
                    

                    <select className={targetUsageError ? "register__dropdown--error" : "register__dropdown"} onChange={onUsageChanged} value={targetUsage}>
                        <option value="-1">کاربری</option>
                        {props.usages.map((usage) => {
                            return (<option key={usage.id} value={usage.id}>{usage.name}</option>)
                        })}
                    </select>
                    <select className={brandValueError ? "register__dropdown--error" : "register__dropdown"} value={brandValue} onChange={onBrandValueChanged}>
                        <option value="-1">برند</option>
                        {
                            props.usageBrands.map((el, idx) => (
                                <option key={idx} value={el.id}>{el.name}</option>
                            ))
                        }
                    </select>
                    <select className={vehicleValueError ? "register__dropdown--error" : "register__dropdown"} value={vehicleValue} onChange={onVehicleValueChanged}>
                        <option value="-1">تیپ</option>
                        {
                            props.validVehicles.map((el, idx) => (
                                <option key={idx} value={el.id}>{el.name}</option>
                            ))
                        }
                    </select>
                    < input
                        className = {
                            fromPriceError ? "register__dropdown--error" : "register__dropdown"
                        }
                        value = {
                            fromPrice === "" ? "" : Numeral(fromPrice).format('0,0')
                        }
                        onChange = {
                            onFromPriceValueChanged
                        }
                        type = "text"
                        placeholder = "از قیمت" > 
                    </input>
                    < input
                        className = {
                            toPriceError ? "register__dropdown--error" : "register__dropdown"
                        }
                        value = {
                            toPrice === "" ? "" : Numeral(toPrice).format('0,0')
                        }
                        onChange = {
                            onToPriceValueChanged
                        }
                        type = "text"
                        placeholder = "تا قیمت" > 
                    </input>
                    <input 
                        className = {
                            fromYearError ? "register__dropdown--error" : "register__dropdown"
                        }
                        value = {
                            fromYear
                        }
                        onChange = {
                            onFromYearChanged
                        }
                        type = "text"
                        placeholder = "از سال" > 
                    </input>
                    <input 
                        className = {
                            toYearError ? "register__dropdown--error" : "register__dropdown"
                        }
                        value = {
                            toYear
                        }
                        onChange = {
                            onToYearChanged
                        }
                        type = "text"
                        placeholder = "تا سال" > 
                    </input>
                </div>
                <div className="optimized__d-flex-class flex-row-reverse">
                    <button disabled={isSending} className="register__button flex-grow-1 px-1 py-3 mx-1" onClick={onNextPressed}>ثبت گوش به زنگ</button>
                </div>
            </div>
        </div>
    );
}

const mapStateToProps = (state, props) => ({
    usages: state.vehicleConfigs.general.usage,
    usageBrands: state.vehicleConfigs.usageBrands,
    validVehicles: state.vehicleConfigs.vehicles
});

const mapDispatchToProps = (dispatch) => ({
    fetchBrands: (category) => dispatch(startgetVehicleBrands(category)),
    fetchVehicles: (brand, category) => dispatch(startgetValidVehicle(brand, category)),
    createAd: (body) => dispatch(startCreateAlarm(body))
});

export default connect(mapStateToProps, mapDispatchToProps)(JobRegister);